"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgAccept(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0a8 8 0 110 16 8 8 0 010-16zm2.893 4.327l-4.244 4.242-1.542-1.542-1.414 1.414 2.957 2.957 5.657-5.657z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Accept')(SvgAccept);
//# sourceMappingURL=Accept.js.map